<template>
  <div>
    <i class="icon-plus-circle"></i>
    <i class="icon-mail"></i>
    <i class="icon-error"></i>
    <i class="icon-bell"></i>
    <i class="icon-arrow"></i>
    <i class="icon-eye"></i>
    <i class="icon-comment"></i>
    <i class="icon-checkbox-empty"></i>
    <i class="icon-checkbox-full"></i>
    <i class="icon-radio-full"></i>
    <i class="icon-radio-empty"></i>
    <i class="icon-upload"></i>
    <i class="icon-chevron-b"></i>
    <i class="icon-fullview"></i>
    <i class="icon-mail-1"></i>
    <i class="icon-person"></i>
    <i class="icon-phone"></i>
    <i class="icon-net"></i>
    <i class="icon-play"></i>
    <i class="icon-check"></i>
    <i class="icon-dev"></i>
    <i class="icon-draft"></i>
    <i class="icon-fav-empty"></i>
    <i class="icon-file-pdf2"></i>
    <i class="icon-flag"></i>
    <i class="icon-flag2"></i>
    <i class="icon-img"></i>
    <i class="icon-logout"></i>
    <i class="icon-pending"></i>
    <i class="icon-time"></i>
    <i class="icon-send"></i>
    <i class="icon-vote-empty"></i>
    <i class="icon-vote-filled"></i>
    <i class="icon-vote-up"></i>
    <i class="icon-remove"></i>
    <i class="icon-report"></i>
    <i class="icon-progress"></i>
    <i class="icon-plus"></i>
    <i class="icon-close"></i>
    <i class="icon-info"></i>
    <i class="icon-switch-account"></i>
    <i class="icon-menu"></i>
    <i class="icon-list"></i>
    <i class="icon-sort"></i>
    <i class="icon-filter"></i>
    <i class="icon-respond"></i>
    <i class="icon-attach"></i>
    <i class="icon-search"></i>

    <br><br>Pages:<br><br>
    <a href="/web/">Home</a><br>
    <a href="/login">Login</a><br>
    <a href="/403">403</a><br>
    <a href="/404">404</a><br>
    <a href="/500">500</a><br>
    <a href="/web/idea/52fec67046e610510de7b9787221d2dd/">Idea: single</a><br>
    <a href="/web/challenge/90">Challenge: single</a><br>
    <a href="/web/idea/new">Idea: new</a><br>
    <a href="/web/profile">Profile</a><br>
    <a href="/web/ideas">Ideas</a><br>
    <a href="/web/page/about-sap-reenergize">About</a><br>
    <a href="/web/contact-us">Contact</a><br>
    <a href="/web/news">News</a><br>
    <a href="/web/news-single">News: single</a><br>
    <a href="/web/agenda">Agenda</a><br>
    <a href="/web/page/sap-gtm-portfolio">SAP GTM Portfolio</a><br>
    <a href="/web/page/sap-gtm-portfolio/solution/64d0b2772bc4f3fee6afe2c808177a44">GTM Single</a><br>
    <a href="/web/engage-for-business">Engage For Business</a><br>
    <a href="/web/privacy-policy">Privacy Policy</a>

    <form class="form--oneliner">
      <div class="input-wrapper">
        <input type="text" placeholder="Search...">
      </div>
      <button><i class="icon-search"></i></button>
    </form>

    <Selector
      :id="'sort'"
      :filterKey="'sort'"
      :options="{
        isMultiple: false,
        mobileView: true
       }"
      :selectorOptions="select"
    />
  </div>
</template>

<script>
import Selector from "@/components/forms/Selector";
export default {
name: "Tester",
components: {Selector},
data () {
  return {
    select: ['a', 'b', 'c']
  }
}
}
</script>

<style scoped>

</style>
